import { toast } from 'react-toastify';
import {
     SYSTEM_ADMIN_PATH,
     API_SYSTEM_ADMIN_GET_ALL_PRODUCTS,
     API_SYSTEM_ADMIN_PRODUCT,
     API_SYSTEM_ADMIN_PRODUCTS,
     API_SYSTEM_ADMIN_PRODUCTS_DELETE_CHECKING,
} from '../../../../constants';
import { toastError } from '../../../../utils';
import { callApi } from '../../../../apiCaller';

import { setIsWaiting, setIsLoading, setRemoveLoading, setShowRemovePopup, setShowRelatedObjectWarningPopup } from '../../../../actions/general';
import { setAdminProductDetails } from './TrainingProduct/ProductDetails/actions';

export const SET_ADMIN_PRODUCTS = 'setAdminProducts';
export const ADD_ADMIN_PRODUCT = 'addAdminProduct';
export const UPDATE_ADMIN_PRODUCT = 'updateAdminProduct';
export const DELETE_ADMIN_PRODUCT = 'deleteAdminProduct';

export const setAdminProducts = (products) => {
     return {
          type: SET_ADMIN_PRODUCTS,
          payload: products,
     };
};

const addAdminProduct = (product) => {
     return {
          type: ADD_ADMIN_PRODUCT,
          payload: product,
     };
};

export const updateAdminProduct = (product) => {
     return {
          type: UPDATE_ADMIN_PRODUCT,
          payload: product,
     };
};

const deleteAdminProduct = (productId) => {
     return {
          type: DELETE_ADMIN_PRODUCT,
          payload: productId,
     };
};

export const fetchAdminProductsRequest = () => (dispatch) => {
     dispatch(setIsLoading(true));
     callApi(API_SYSTEM_ADMIN_GET_ALL_PRODUCTS, 'GET')
          .then((response) => {
               if (response.status === 200) {
                    dispatch(setAdminProducts(response.data));
               } else {
                    toastError(response);
               }
          })
          .finally(() => dispatch(setIsLoading(false)));
};

export const addAdminProductRequest = (product, nextDispatch) => (dispatch) => {
     dispatch(setIsWaiting(true));

     return callApi(API_SYSTEM_ADMIN_PRODUCTS, 'POST', product)
          .then((response) => {
               if (response.status === 200) {
                    const newProduct = response.data;
                    dispatch(addAdminProduct(newProduct));

                    nextDispatch.navigate(SYSTEM_ADMIN_PATH.TRAINING_PRODUCTS_DETAIL.replace(':id', newProduct.id));
                    toast.success('Created successfully');
               } else {
                    toastError(response);
               }
          })
          .finally(() => {
               dispatch(setIsWaiting(false));
          });
};

export const updateAdminProductRequest = (productId, newProduct, nextDispatch) => (dispatch, getState) => {
     const { setSubmitting, setShowPopupDetail } = nextDispatch;
     const dataAddProduct = getState().admin.dataAddProduct;
     const productDetails = getState().admin.productDetails;

     const productData = { ...newProduct };
     delete productData.events;
     delete productData.faqs;

     dispatch(setIsWaiting(true));
     if (setSubmitting) {
          setSubmitting(true);
     }

     callApi(API_SYSTEM_ADMIN_PRODUCT.replace(':id', productId), 'PUT', productData)
          .then((response) => {
               if (response.status === 200) {
                    const newProductData = response.data;

                    const productType = dataAddProduct?.productTypes
                         .filter((productTypeItem) => productTypeItem.id === newProductData.productTypeId)
                         .map((productTypeItem) => {
                              return {
                                   name: productTypeItem.name,
                                   trainingProductType: productTypeItem.trainingProductType,
                              };
                         })[0];

                    if (nextDispatch?.setProduct) {
                         nextDispatch.setProduct({
                              ...nextDispatch.product,
                              ...newProductData,
                              ...{ productType },
                         });
                    }

                    const newProductDetails = {
                         ...productDetails,
                         ...newProductData,
                    };

                    dispatch(setAdminProductDetails(newProductDetails));
                    dispatch(updateAdminProduct(newProductData));

                    toast.success('Update successfully');
                    if (nextDispatch?.navigate) {
                         nextDispatch.navigate(SYSTEM_ADMIN_PATH.TRAINING_PRODUCTS_DETAIL.replace(':id', productId), { replace: true });
                    }
               } else {
                    toastError(response);
               }
          })
          .finally(() => {
               dispatch(setIsWaiting(false));
               if (setSubmitting) {
                    setSubmitting(false);
               }
               if (setShowPopupDetail) {
                    dispatch(setShowPopupDetail(null));
               }
          });
};

export const deleteAdminProductRequest = (id, nextDispatch) => (dispatch) => {
     dispatch(setRemoveLoading(true));
     return callApi(API_SYSTEM_ADMIN_PRODUCT.replace(':id', id), 'DELETE')
          .then((response) => {
               if (response.status === 200) {
                    dispatch(deleteAdminProduct(id));

                    if (nextDispatch && nextDispatch.navigate) {
                         nextDispatch.navigate(SYSTEM_ADMIN_PATH.TRAINING_PRODUCTS, { replace: true });
                    }
                    toast.success('Deleted successfully');
               } else {
                    toastError(response);
               }
          })
          .finally(() => {
               dispatch(setRemoveLoading(false));
               dispatch(setShowRemovePopup(null));
          });
};

export const checkCanDeleteProductRequest = (id) => (dispatch) => {
     callApi(API_SYSTEM_ADMIN_PRODUCTS_DELETE_CHECKING.replace(':id', id), 'GET').then((response) => {
          if (response.status === 200) {
               if (response.data.canDelete) {
                    dispatch(setShowRemovePopup(id));
               }
          } else {
               if (response.data.isUsedForProducts) {
                    dispatch(setShowRemovePopup(null));
                    dispatch(setShowRelatedObjectWarningPopup(response.data.relatedProductId, response.data.message));
               } else {
                    toastError(response);
               }
          }
     });
};

export const checkUpdateProductRequest = (nextDispatch) => (dispatch, getState) => {
     const { isEditing, setFieldValue, setStatusLoading, status, isSubmitForm, handleSubmit, productId } = nextDispatch;

     if (isEditing && !status) {
          setStatusLoading(true);

          callApi(`${API_SYSTEM_ADMIN_PRODUCTS_DELETE_CHECKING.replace(':id', productId)}`, 'GET')
               .then((response) => {
                    if (response.status === 200) {
                         if (response.data.canDelete) {
                              setFieldValue('status', status);
                              if (isSubmitForm) {
                                   setTimeout(() => handleSubmit(), 100);
                              }
                         }
                    } else {
                         if (response.data.isUsedForProducts) {
                              dispatch(setShowRelatedObjectWarningPopup(response.data.relatedProductId, response.data.message));
                         } else {
                              toastError(response);
                         }
                    }
               })
               .finally(() => setStatusLoading(false));
     } else {
          setFieldValue('status', status);
          if (isSubmitForm) {
               setTimeout(() => handleSubmit(), 100);
          }
     }
     // }
};
